<div class="header__login">
    <a href="https://www.planexware.com/" target="_blank" rel="noopener noreferrer">
        <img height="15" src="assets/planexware-white.svg" alt="Planexware" /></a>
</div>
<div class="header__login_body">
    <div class="col-md-12 login__card__wrapper" [formGroup]="desuscripcionForm">

        <mat-card class="login__card">
            <div *ngIf="loading" class="spinner-wrapper">
                <mat-spinner diameter="44" class="spinner"></mat-spinner>
            </div>
            <div *ngIf="!loading && !enviado">
                <h2 class="desuscripcion_title">
                    {{ "SUSCRIPCION_DADA_DE_BAJA" | translate : {notificacion: notificacion | translate} }}
                </h2>

                <mat-checkbox class="desuscripcion_checkbox" formControlName="desuscribirTodas">
                    {{"DESUSCRIBIRME_TODAS_NOTIFICACIONES" | translate}}
                </mat-checkbox>

                <h2 class="motivos_title">
                    {{ "INDIQUE_RAZON_DADA_DE_BAJA" | translate }}
                </h2>
                <mat-radio-group formControlName="motivo">
                    <div class="motivos_options" *ngFor="let motivo of motivos">

                        <mat-radio-button [value]="motivo">{{
                            motivo.resourceKey + "_DESC" | translate
                            }}</mat-radio-button>

                    </div>
                </mat-radio-group>
                <div>
                    <button mat-raised-button class="enviar" mat-button (click)="send()">
                        {{ "ENVIAR" | translate | uppercase }}
                    </button>
                </div>
            </div>
            <div *ngIf="!loading && enviado">
                <div class="check-wrapper">
                    <mat-icon class="check-circle flex-center green-check">check_circle</mat-icon>
                    <h2 class="solicitud_procesada_title">
                        {{ "SOLICITUD_PROCESADA" | translate }}
                    </h2>
                </div>


                <p class="solicitud_procesada_mensaje"
                    [innerHtml]="'HEMOS_REGISTRADO_SU_PREFERENCIA_CON_EXITO' | translate "></p>

                <p class="solicitud_procesada_mensaje">
                    {{ "MUCHAS_GRACIAS" | translate }}
                </p>

                <img class="imagen-planex" height="30" src="assets/planexware-white.svg" alt="Planexware" />


            </div>
        </mat-card>
    </div>
</div>